import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "subheader-icon fal fa-boxes" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"panel-hdr mt-2\"><h2>Saldo de <span class=\"fw-300\"><i>Lotes</i></span></h2><div class=\"panel-toolbar\"><button class=\"btn btn-panel\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\"></button><button class=\"btn btn-panel\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\"></button></div></div>", 1)
const _hoisted_9 = { class: "panel-container" }
const _hoisted_10 = { class: "panel-content" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "card-body py-2 px-3" }
const _hoisted_14 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_15 = {
  class: "h4 mb-0 font-weight-bold",
  style: {"color":"#3a3f51"}
}
const _hoisted_16 = {
  class: "text-muted",
  style: {"font-size":"0.65rem"}
}
const _hoisted_17 = { class: "row mb-2 align-items-center" }
const _hoisted_18 = { class: "col-xl-4 col-lg-5 col-md-6 col-sm-8 col-12 mb-1" }
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" })
  ])
], -1)
const _hoisted_21 = {
  class: "col-xl-auto col-auto mb-1 d-flex",
  style: {"gap":"6px"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus-circle" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sync-alt" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_25 = { class: "col text-right text-muted small mb-1" }
const _hoisted_26 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = { class: "text-right" }
const _hoisted_34 = {
  class: "modal fade",
  id: "lote-registrar-modal",
  tabindex: "-1",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_35 = { class: "modal-dialog" }
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-tag mr-1" }),
  /*#__PURE__*/_createTextVNode(" Registrar Lote")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "×", -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "modal-body" }
const _hoisted_41 = { class: "form-group mb-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-sm font-weight-bold mb-0" }, "Producto", -1)
const _hoisted_43 = { style: {"position":"relative"} }
const _hoisted_44 = {
  key: 0,
  class: "fal fa-spinner fa-spin",
  style: {"position":"absolute","right":"10px","top":"50%","transform":"translateY(-50%)","color":"#aaa"}
}
const _hoisted_45 = {
  key: 1,
  style: {"position":"absolute","z-index":"9999","width":"100%","background":"#fff","border":"1px solid #ced4da","border-top":"none","border-radius":"0 0 4px 4px","max-height":"220px","overflow-y":"auto","box-shadow":"0 4px 10px rgba(0,0,0,0.12)"}
}
const _hoisted_46 = ["onMousedown", "onMouseenter"]
const _hoisted_47 = { class: "font-weight-bold" }
const _hoisted_48 = {
  class: "text-muted",
  style: {"font-size":"0.75rem"}
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_51 = {
  key: 0,
  class: "alert alert-info py-1 px-2 mb-3 small"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-box mr-1" }, null, -1)
const _hoisted_53 = { class: "form-row" }
const _hoisted_54 = { class: "form-group col-md-6 mb-2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-sm font-weight-bold mb-0" }, [
  /*#__PURE__*/_createTextVNode(" N° Lote "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-muted font-weight-normal" }, "(opcional)")
], -1)
const _hoisted_56 = { class: "form-group col-md-6 mb-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-sm font-weight-bold mb-0" }, [
  /*#__PURE__*/_createTextVNode(" F. Vencimiento "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-muted font-weight-normal" }, "(opcional)")
], -1)
const _hoisted_58 = { class: "form-group mb-0" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-sm font-weight-bold mb-0" }, [
  /*#__PURE__*/_createTextVNode(" Cantidad "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_60 = { class: "modal-footer pt-1" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-save mr-1" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content-overlay",
  "data-action": "toggle",
  "data-class": "mobile-nav-on"
}, null, -1)

import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import authApi from '@/modules/auth/api/authApi';
import utils from '@/utils/utils';
import { useLoading } from 'vue-loading-overlay';

declare const $: any;


export default /*#__PURE__*/_defineComponent({
  __name: 'LotesAdminView',
  setup(__props) {

const store = useStore();
const $loading = useLoading();

// ── Semaphore definitions ──────────────────────────────────────────────────────

const categoriasSemaforo = [
    { key: 'vencido',         bg: '#6f1521', color: '#fff',    bgLight: '#f8e8ea', label: 'Vencido',    rango: '< 0 días',        icon: 'fa-times-circle'       },
    { key: 'critico',         bg: '#dc3545', color: '#fff',    bgLight: '#fde8eb', label: 'Crítico',    rango: '0 – 30 días',     icon: 'fa-exclamation-circle' },
    { key: 'precaucion',      bg: '#fd7e14', color: '#fff',    bgLight: '#fff0e6', label: 'Precaución', rango: '31 – 60 días',    icon: 'fa-exclamation-triangle'},
    { key: 'alerta',          bg: '#d39e00', color: '#212529', bgLight: '#fff8e1', label: 'Alerta',     rango: '61 – 90 días',    icon: 'fa-clock'              },
    { key: 'vigente',         bg: '#198754', color: '#fff',    bgLight: '#e8f5ee', label: 'Vigente',    rango: '> 90 días',       icon: 'fa-check-circle'       },
    { key: 'sin_vencimiento', bg: '#6c757d', color: '#fff',    bgLight: '#f0f1f2', label: 'Sin fecha',  rango: 'Sin vencimiento', icon: 'fa-calendar-minus'     },
];

const semaforoInfo = (dias: number | null) => {
    if (dias === null || dias === undefined) return categoriasSemaforo[5];
    if (dias < 0)   return categoriasSemaforo[0];
    if (dias <= 30) return categoriasSemaforo[1];
    if (dias <= 60) return categoriasSemaforo[2];
    if (dias <= 90) return categoriasSemaforo[3];
    return categoriasSemaforo[4];
};

const getSemaforoKey = (item: any): string => {
    const dias = item.dias_restantes;
    if (dias === null || dias === undefined) return 'sin_vencimiento';
    return semaforoInfo(Number(dias)).key;
};

// ── Reactive date tracking ─────────────────────────────────────────────────────

const fechaHoyStr = ref('');
let midnightTimer: ReturnType<typeof setTimeout> | null = null;
let dailyInterval: ReturnType<typeof setInterval> | null = null;

const actualizarFecha = () => {
    const hoy = new Date();
    const d = String(hoy.getDate()).padStart(2, '0');
    const m = String(hoy.getMonth() + 1).padStart(2, '0');
    fechaHoyStr.value = `${d}/${m}/${hoy.getFullYear()}`;
};

const programarMedianoche = () => {
    const ahora = new Date();
    const manana = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate() + 1);
    const msHastaMedianoche = manana.getTime() - ahora.getTime();
    midnightTimer = setTimeout(() => {
        actualizarFecha();
        cargarLotes();
        dailyInterval = setInterval(() => {
            actualizarFecha();
            cargarLotes();
        }, 86400000);
    }, msHastaMedianoche);
};

// ── Table ──────────────────────────────────────────────────────────────────────

const headers = [
    { text: 'Producto',         value: 'nombre_producto',       sortable: true  },
    { text: 'N° Lote',          value: 'numero_lote',           sortable: true  },
    { text: 'F. Vencimiento',   value: 'fecha_vencimiento_fmt', sortable: true  },
    { text: 'Días Rest.',       value: 'dias_restantes',        sortable: true  },
    { text: 'Cant. Inicial',    value: 'cantidad_inicial',      sortable: true  },
    { text: 'Saldo Disponible', value: 'cantidad_disponible',   sortable: true  },
    { text: '% Saldo',          value: 'porcentaje',            sortable: false },
    { text: 'Fecha Registro',   value: 'fecha_registro',        sortable: true  },
];

const lotesOriginales = ref<any[]>([]);
const lotesFiltrados = ref<any[]>([]);
const textoFiltro = ref('');
const filtroSemaforo = ref('');

const resumen = computed(() => {
    const counts: Record<string, number> = {
        vencido: 0, critico: 0, precaucion: 0, alerta: 0, vigente: 0, sin_vencimiento: 0
    };
    for (const l of lotesOriginales.value) {
        const key = getSemaforoKey(l);
        counts[key] = (counts[key] ?? 0) + 1;
    }
    return counts;
});

const catActiva = computed(() =>
    categoriasSemaforo.find(c => c.key === filtroSemaforo.value) ?? null
);

const porcentajeSaldo = (item: any): string => {
    const inicial = Number(item.cantidad_inicial);
    if (inicial === 0) return '0';
    return ((Number(item.cantidad_disponible) / inicial) * 100).toFixed(0);
};

const toggleFiltroSemaforo = (key: string) => {
    filtroSemaforo.value = filtroSemaforo.value === key ? '' : key;
    filtrar();
};

const limpiarFiltro = () => {
    filtroSemaforo.value = '';
    filtrar();
};

const filtrar = () => {
    lotesFiltrados.value = lotesOriginales.value.filter((l: any) => {
        const coincideTexto = textoFiltro.value === ''
            || (l.nombre_producto || '').toLowerCase().includes(textoFiltro.value.toLowerCase())
            || (l.numero_lote || '').toLowerCase().includes(textoFiltro.value.toLowerCase());

        const coincideSemaforo = filtroSemaforo.value === ''
            || getSemaforoKey(l) === filtroSemaforo.value;

        return coincideTexto && coincideSemaforo;
    });
};

const cargarLotes = async () => {
    const loader = $loading.show(utils.configuracionLoading);
    try {
        const { data } = await authApi.get(
            `/lotes/obtener-lotes/${store.getters['auth/getIdSucursal']}`,
            { headers: { 'Authorization': 'Bearer ' + store.getters['auth/getToken'] } }
        );
        loader.hide();
        if (data.ok) {
            lotesOriginales.value = data.datos;
            filtrar();
        } else {
            utils.mostrarMensaje({ descripcion: data.mensaje.descripcion, tipoMensaje: data.mensaje.tipoMensaje });
        }
    } catch (error) {
        loader.hide();
        utils.mostrarMensajeErrorApi(error);
    }
};

// ── Modal: Registrar Lote ──────────────────────────────────────────────────────

const busquedaProducto     = ref('');
const productosEncontrados = ref<any[]>([]);
const hoveredId            = ref<number | null>(null);
const buscando             = ref(false);
const grabando             = ref(false);
let   debounceTimer: ReturnType<typeof setTimeout> | null = null;

const loteForm = ref({
    id_producto_stock: 0,
    nombre_producto: '',
    stock: 0,
    numero_lote: '',
    fecha_vencimiento: '',
    cantidad: 0
});

const resetForm = () => {
    busquedaProducto.value = '';
    productosEncontrados.value = [];
    hoveredId.value = null;
    if (debounceTimer) clearTimeout(debounceTimer);
    loteForm.value = { id_producto_stock: 0, nombre_producto: '', stock: 0, numero_lote: '', fecha_vencimiento: '', cantidad: 0 };
};

const abrirModal = () => {
    resetForm();
    ($('#lote-registrar-modal') as any).modal('show');
};

const cerrarModal = () => {
    ($('#lote-registrar-modal') as any).modal('hide');
};

const buscarProductos = async () => {
    const termino = busquedaProducto.value.trim();
    if (termino.length < 2) return;
    buscando.value = true;
    try {
        const { data } = await authApi.get(
            `/productos/obtener-productos-stock/${store.getters['auth/getIdSucursal']}/${encodeURIComponent(termino)}`,
            { headers: { 'Authorization': 'Bearer ' + store.getters['auth/getToken'] } }
        );
        if (data.ok) productosEncontrados.value = data.datos;
    } catch (error) {
        utils.mostrarMensajeErrorApi(error);
    } finally {
        buscando.value = false;
    }
};

const onBusquedaInput = () => {
    if (debounceTimer) clearTimeout(debounceTimer);
    if (busquedaProducto.value.trim().length < 2) {
        productosEncontrados.value = [];
        return;
    }
    debounceTimer = setTimeout(buscarProductos, 300);
};

const onBlurBusqueda = () => {
    productosEncontrados.value = [];
};

const seleccionarProducto = (p: any) => {
    loteForm.value.id_producto_stock = p.id_producto_stock;
    loteForm.value.nombre_producto   = p.nombre;
    loteForm.value.stock             = p.stock;
    busquedaProducto.value = p.nombre;
    productosEncontrados.value = [];
};

const grabarLote = async () => {
    if (loteForm.value.id_producto_stock === 0) {
        utils.mostrarMensaje({ descripcion: 'Seleccione un producto.', tipoMensaje: 'warning' });
        return;
    }
    if (!loteForm.value.cantidad || loteForm.value.cantidad <= 0) {
        utils.mostrarMensaje({ descripcion: 'Ingrese una cantidad válida mayor a cero.', tipoMensaje: 'warning' });
        return;
    }
    grabando.value = true;
    try {
        const { data } = await authApi.post(
            '/lotes/registrar-lote',
            {
                id_producto_stock: loteForm.value.id_producto_stock,
                id_sucursal:       store.getters['auth/getIdSucursal'],
                numero_lote:       loteForm.value.numero_lote || null,
                fecha_vencimiento: loteForm.value.fecha_vencimiento || null,
                cantidad:          loteForm.value.cantidad
            },
            { headers: { 'Authorization': 'Bearer ' + store.getters['auth/getToken'] } }
        );
        grabando.value = false;
        utils.mostrarMensaje({ descripcion: data.mensaje.descripcion, tipoMensaje: data.mensaje.tipoMensaje });
        if (data.ok) {
            cerrarModal();
            await cargarLotes();
        }
    } catch (error) {
        grabando.value = false;
        utils.mostrarMensajeErrorApi(error);
    }
};

onMounted(async () => {
    actualizarFecha();
    programarMedianoche();
    await cargarLotes();
});

onUnmounted(() => {
    if (midnightTimer) clearTimeout(midnightTimer);
    if (dailyInterval) clearInterval(dailyInterval);
});

return (_ctx: any,_cache: any) => {
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categoriasSemaforo, (cat) => {
                    return _createElementVNode("div", {
                      class: "col-xl-2 col-lg-4 col-md-4 col-6 mb-2",
                      key: cat.key
                    }, [
                      _createElementVNode("div", {
                        class: "card h-100 mb-0",
                        style: _normalizeStyle([{"cursor":"pointer","transition":"box-shadow 0.15s, background-color 0.15s"}, {
                                            borderLeft: '4px solid ' + cat.bg,
                                            backgroundColor: filtroSemaforo.value === cat.key ? cat.bgLight : '#fff',
                                            boxShadow: filtroSemaforo.value === cat.key
                                                ? '0 0 0 2px ' + cat.bg
                                                : '0 1px 3px rgba(0,0,0,0.1)'
                                        }]),
                        onClick: ($event: any) => (toggleFiltroSemaforo(cat.key))
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", {
                                class: "font-weight-bold text-uppercase mb-1",
                                style: _normalizeStyle({ color: cat.bg, fontSize: '0.7rem' })
                              }, _toDisplayString(cat.label), 5),
                              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(resumen)[cat.key]), 1),
                              _createElementVNode("small", _hoisted_16, _toDisplayString(cat.rango), 1)
                            ]),
                            _createElementVNode("i", {
                              class: _normalizeClass('fal ' + cat.icon + ' fa-2x'),
                              style: {"color":"#d1d3e2"}
                            }, null, 2)
                          ])
                        ])
                      ], 12, _hoisted_12)
                    ])
                  }), 64))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: "Buscar por producto o N° lote",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textoFiltro).value = $event)),
                        onInput: filtrar
                      }, null, 544), [
                        [_vModelText, textoFiltro.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      class: "btn btn-success btn-sm",
                      onClick: abrirModal
                    }, [
                      _hoisted_22,
                      _createTextVNode(" Agregar Lote ")
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-sm",
                      onClick: cargarLotes
                    }, [
                      _hoisted_23,
                      _createTextVNode(" Actualizar ")
                    ]),
                    (filtroSemaforo.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-secondary btn-sm",
                          onClick: limpiarFiltro
                        }, [
                          _hoisted_24,
                          _createTextVNode(" Limpiar ")
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createTextVNode(" Mostrando "),
                    _createElementVNode("strong", null, _toDisplayString(lotesFiltrados.value.length), 1),
                    _createTextVNode(" de "),
                    _createElementVNode("strong", null, _toDisplayString(lotesOriginales.value.length), 1),
                    _createTextVNode(" lotes  |  Hoy: "),
                    _createElementVNode("strong", null, _toDisplayString(fechaHoyStr.value), 1)
                  ])
                ]),
                (filtroSemaforo.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("span", {
                        class: "badge px-2 py-1",
                        style: _normalizeStyle({ backgroundColor: _unref(catActiva)?.bg, color: _unref(catActiva)?.color })
                      }, " Filtro: " + _toDisplayString(_unref(catActiva)?.label), 5)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_EasyDataTable, {
                  headers: headers,
                  items: lotesFiltrados.value,
                  "border-cell": "",
                  alternating: "",
                  "buttons-pagination": ""
                }, {
                  "item-nombre_producto": _withCtx((item) => [
                    _createElementVNode("span", null, _toDisplayString(item.nombre_producto), 1)
                  ]),
                  "item-numero_lote": _withCtx((item) => [
                    _createElementVNode("span", null, _toDisplayString(item.numero_lote || '-'), 1)
                  ]),
                  "item-fecha_vencimiento_fmt": _withCtx((item) => [
                    (item.fecha_vencimiento_fmt)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(item.fecha_vencimiento_fmt), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_28, "-"))
                  ]),
                  "item-dias_restantes": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_29, [
                      (item.dias_restantes !== null && item.dias_restantes !== undefined)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "badge px-2 py-1",
                            style: _normalizeStyle({
                                                backgroundColor: semaforoInfo(Number(item.dias_restantes)).bg,
                                                color: semaforoInfo(Number(item.dias_restantes)).color,
                                                minWidth: '70px',
                                                display: 'inline-block'
                                            })
                          }, _toDisplayString(item.dias_restantes) + " día" + _toDisplayString(Number(item.dias_restantes) === 1 ? '' : 's'), 5))
                        : (_openBlock(), _createElementBlock("span", _hoisted_30, "-"))
                    ])
                  ]),
                  "item-cantidad_inicial": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(item.cantidad_inicial), 1)
                  ]),
                  "item-cantidad_disponible": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("strong", {
                        class: _normalizeClass({ 'text-danger': Number(item.cantidad_disponible) === 0 })
                      }, _toDisplayString(item.cantidad_disponible), 3)
                    ])
                  ]),
                  "item-porcentaje": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_33, _toDisplayString(porcentajeSaldo(item)) + "%", 1)
                  ]),
                  _: 1
                }, 8, ["items"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", { class: "modal-header" }, [
            _hoisted_37,
            _createElementVNode("button", {
              type: "button",
              class: "close",
              onClick: cerrarModal
            }, _hoisted_39)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((busquedaProducto).value = $event)),
                  onInput: onBusquedaInput,
                  onBlur: onBlurBusqueda,
                  placeholder: "Buscar por nombre o código de barras...",
                  autocomplete: "off"
                }, null, 544), [
                  [_vModelText, busquedaProducto.value]
                ]),
                (buscando.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                  : _createCommentVNode("", true),
                (productosEncontrados.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productosEncontrados.value, (p) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: p.id_producto_stock,
                          onMousedown: _withModifiers(($event: any) => (seleccionarProducto(p)), ["prevent"]),
                          style: _normalizeStyle([{"padding":"7px 12px","cursor":"pointer","border-bottom":"1px solid #f0f0f0","font-size":"0.85rem"}, { backgroundColor: hoveredId.value === p.id_producto_stock ? '#e8f4fd' : '#fff' }]),
                          onMouseenter: ($event: any) => (hoveredId.value = p.id_producto_stock),
                          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (hoveredId.value = null))
                        }, [
                          _createElementVNode("div", _hoisted_47, _toDisplayString(p.nombre), 1),
                          _createElementVNode("div", _hoisted_48, [
                            (p.codigo_barras)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_49, "CB: " + _toDisplayString(p.codigo_barras) + "  • ", 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(" Stock: " + _toDisplayString(p.stock), 1)
                          ])
                        ], 44, _hoisted_46))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (busquedaProducto.value.length > 0 && busquedaProducto.value.length < 2)
                ? (_openBlock(), _createElementBlock("small", _hoisted_50, " Escriba al menos 2 caracteres para buscar. "))
                : _createCommentVNode("", true)
            ]),
            (loteForm.value.id_producto_stock > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("strong", null, _toDisplayString(loteForm.value.nombre_producto), 1),
                  _createTextVNode("  |  Stock actual: "),
                  _createElementVNode("strong", null, _toDisplayString(loteForm.value.stock), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((loteForm.value.numero_lote) = $event)),
                  placeholder: "Ej: LOT-2024-001"
                }, null, 512), [
                  [_vModelText, loteForm.value.numero_lote]
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((loteForm.value.fecha_vencimiento) = $event))
                }, null, 512), [
                  [_vModelText, loteForm.value.fecha_vencimiento]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((loteForm.value.cantidad) = $event)),
                min: "0.01",
                step: "1",
                placeholder: "0"
              }, null, 512), [
                [
                  _vModelText,
                  loteForm.value.cantidad,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: grabarLote,
              disabled: grabando.value
            }, [
              _hoisted_62,
              _createTextVNode(" Grabar ")
            ], 8, _hoisted_61),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger btn-sm",
              onClick: cerrarModal
            }, "Cancelar")
          ])
        ])
      ])
    ]),
    _hoisted_63
  ], 64))
}
}

})